module.exports = __webpack_public_path__ + "static/media/loader.695888b4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/loader.gif
// module id = 1787
// module chunks = 0